


































import { Vue, Component, Prop } from 'vue-property-decorator';
import EditorNodeDivider from '@/editor/editor-block-view/components/EditorNodeDivider.vue';
import EditorNodeText from '@/editor/editor-block-view/components/EditorNodeText.vue';
import EditorNodeTable from '@/editor/editor-block-view/components/EditorNodeTable.vue';
import EditorNodeImage from '@/editor/editor-block-view/components/EditorNodeImage.vue';
import { INode, IMergeValues } from '@/editor/types';
import { ENodeType } from '@/editor/types/enums';
@Component({
  components: {
    EditorNodeDivider,
    EditorNodeImage,
    EditorNodeTable,
    EditorNodeText,
  },
  data: () => ({
    ENodeType,
  }),
})
export default class EditorCell extends Vue {
  @Prop() nodes: INode[];
  @Prop() mergeValues: IMergeValues;

  getNodeType(nodes: INode[], index: number): ENodeType {
    return nodes[index]?.type;
  }
}
